import { JsonFormsState } from '@jsonforms/core'
import filter from 'lodash/filter'

export const getErrorsFromScope = (state: JsonFormsState, scope?: string) => {
  if (!scope) {
    return []
  }
  const additionalErrors = state.jsonforms.core?.additionalErrors
  return filter(additionalErrors, (err) => err.instancePath === scope.slice(1))
}